import { localDatabaseUrls } from "../backend/constants";
import { getAPI } from "../backend/commons";
import { getJWTToken } from "../shared/fetchWrapper/fetchWrapper";
import { getFileXlsx } from "../templates/CostUpload/FileReceiver";
import AlertManager from "../shared/Alert/Alert";

export const downloadRunDetailsReport = async (batchId, type) => {
  const tokenInfo = await getJWTToken();
  if (!tokenInfo) {
    window.location.href = "/";
    return null;
  }

  const sanitizedType = encodeURIComponent(type);
  const sanitizedBatchId = encodeURIComponent(batchId);
  const apiUrl = `${localDatabaseUrls.baseURL}api/v1/landed-cost/reports/${sanitizedBatchId}/${sanitizedType}`;

  try {
    const response = await getAPI(apiUrl, tokenInfo);

    if (!response || !response.ok) {
      const errorData = await response?.json?.().catch(() => ({}));
      throw new Error(errorData?.message || response?.statusText || "Unable to download report.");
    }

    const contentDisposition = response.headers?.get?.("content-disposition");
    let fileName = `${type}_${batchId}.xlsx`;
    if (contentDisposition && contentDisposition.includes("filename=")) {
      const match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
      if (match && match[1]) {
        fileName = match[1].replace(/['"]/g, "");
      }
    }

    await getFileXlsx(fileName, response, type);
    return { fileName };
  } catch (error) {
    AlertManager.error(error?.message || "Unable to download report.", { contactSupport: false });
    return null;
  }
};

export default downloadRunDetailsReport;
